<app-layout>
  <app-voltar route="listagem/agendamento" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (change)="this.consultarValor()">
      <div class="formList">
        <app-input
          type="datetime-local"
          label="Data do Agendamento"
          name="DT_AGND"
          width="100%"
          formControlName="DT_AGND"
          [requiredInput]="true"></app-input>
        <app-input
          type="text"
          label="Motorista"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          [requiredInput]="true"
          [disabled]="true"></app-input>
        <app-input
          type="select"
          label="Placa do Cavalo"
          name="FK_CAVA"
          formControlName="FK_CAVA"
          placeholder="Selecione"
          [requiredInput]="true"
          [disabled]="disabledAgendamento"
          [selectData]="cavaloOptions"
          (ngModelChange)="escolherPlacaCavalo($event)"></app-input>
        <app-input
          type="select"
          label="Carreta 1"
          name="FK_CRRT_1"
          formControlName="FK_CRRT_1"
          placeholder="Selecione"
          [disabled]="disabledAgendamento"
          [selectData]="carretaOptions1"
          (ngModelChange)="escolherPlacaCarreta($event, 1)"></app-input>
        <app-input
          type="select"
          label="Carreta 2"
          name="FK_CRRT_2"
          formControlName="FK_CRRT_2"
          placeholder="Selecione"
          [selectData]="carretaOptions2"
          (ngModelChange)="escolherPlacaCarreta($event, 2)"></app-input>
        <app-input
          type="select"
          label="Carreta 3"
          name="FK_CRRT_3"
          formControlName="FK_CRRT_3"
          placeholder="Selecione"
          [disabled]="disabledAgendamento"
          [selectData]="carretaOptions3"
          (ngModelChange)="escolherPlacaCarreta($event, 3)"></app-input>
        <app-input
          type="select"
          label="Serviço"
          name="FK_SRVC"
          formControlName="FK_SRVC"
          placeholder="Selecione"
          [requiredInput]="true"
          [disabled]="disabledAgendamento"
          [selectData]="servicoOptions"
          (ngModelChange)="escolherServico($event)"></app-input>
      </div>
      <app-input
        type="textarea"
        label="Observação"
        name="TX_OBSV_AGND"
        formControlName="TX_OBSV_AGND"
        placeholder="Digite aqui"
        width="100%"
        [requiredInput]="false"
        [disabled]="disabledAgendamento"></app-input>
      <p *ngIf="visible">
        As opções de serviço(s) selecionada(s), resultam no custo de R$
        {{ this.valorServico }}.
      </p>
      <app-botao
        *ngIf="!this.title.includes('Visualização')"
        type="cadastro"
        text="Concluir Agendamento"
        class="botao-cadastro"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
